import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

export const HEADER_PADDING_MOBILE = SPACING.S24;
export const HEADER_PADDING_DESKTOP = SPACING.LG;
